export const SCREENS_ID = {
  HOME: 'home',
  PRODUCT: 'product',
  QUICK_ORDER: 'quick-order',
  PROMO: 'promo',
  BLOG: 'blog',
};

export const BANNER_TYPES = {
  HEADER: 'header-banner',
  MAIN: 'main-banner',
  SUB: 'sub-banner',
  PRODUCT: 'product-banner',
};

export const PAYMENT_METHOD = [
  { code: 'bank', label: 'Chuyển khoản ngân hàng' },
  { code: 'cod', label: 'Thanh toán bằng tiền mặt khi nhận hàng' },
];

export const PAYMENT_METHOD_STRING = {
  COD: 'cod',
  TRANSFER: 'bank',
};

